import React, {useEffect} from "react";
import Header from "./partials/header";
import {Helmet} from "react-helmet-async";
import {useLocation} from "react-router-dom";

export default function MainLayout( {children} ) {
  useEffect(() => {
    document.body.setAttribute("data-layout", "topnav");
    document.body.setAttribute("data-bs-theme", "light");
    document.body.setAttribute("data-layout-mode", "fluid");
    document.body.setAttribute("data-topbar-color", "dark");
    document.body.setAttribute("data-sidenav-size", "default");
    document.body.setAttribute("data-layout-position", "fixed");
  }, []);

  const location = useLocation();

  const defaultTitle="SweatNow - Follow. Sweat. Repeat!";
  const defaultDescription="The only fitness reservation app that gives you the freedom to follow your favorite TOP trainers and search for workouts based on location, time, and instructor.";
  const defaultImage="https://s3.amazonaws.com/sweatnow-prod/assets/landing-page-background.jpg";
  const canonicalUrl=`${window.location.protocol}//${window.location.host}${location.pathname}`;

  return (
    <>
      <div className={"wrapper"}>
        <div className={"content-page"}>
          <div className={"content pt-4"}>
            <Helmet>
              <link rel="canonical" href={canonicalUrl}/>
              <title>{defaultTitle}</title>
              <meta name="description" content={defaultDescription}/>

              {/*apple appstore - but this is also in index.html as it wouldnt work*/}
              <meta name="apple-itunes-app" content={`app-id=${process.env.REACT_APP_APPLE_APPSTORE_ID}`}/>

              {/*facebook*/}
              <meta property="fb:app_id" content={process.env.REACT_APP_ID}/>
              <meta property="og:type" content="website"/>
              <meta property="og:url" content={canonicalUrl}/>
              <meta property="og:title" content={defaultTitle}/>
              <meta property="og:description" content={defaultDescription}/>
              <meta property="og:image" content={defaultImage}/>
              <meta property="og:locale" content="en_US"/>
              <meta property="og:image:alt" content={`${window.location.protocol}//${window.location.host}/assets/images/og-image.png`}/>

              {/*x*/}
              <meta property="twitter:card" content="summary_large_image"/>
              <meta property="twitter:url" content={canonicalUrl}/>
              <meta property="twitter:title" content={defaultTitle}/>
              <meta property="twitter:description" content={defaultDescription}/>
              <meta property="twitter:image" content={defaultImage}/>
            </Helmet>
            <Header/>
            <main>
              {children}
            </main>
          </div>
          {/*<Footer/>*/}
        </div>
      </div>
    </>
  );
}
